const commonUrl = "api/v1"

const apiEndPoints = {
    login: `${commonUrl}/ekutir/user/auth/login`,
    logout: `${commonUrl}/ekutir/user/auth/logout`,
    refreshToken: `${commonUrl}/ekutir/user/auth/refreshToken`,
    userProfile: `${commonUrl}/ekutir/user/auth/profile`,
    updateUserProfile: `${commonUrl}/ekutir/user/auth/profile`,
    uploadProfileImage: `${commonUrl}/ekutir/user/auth/profile/image`,
    deleteProfileImage: `${commonUrl}/ekutir/user/auth/profile/image`, 

    countryMetaData: `${commonUrl}/ekutir/country-metadata`, 
    currenciesMetaData: `${commonUrl}/ekutir/currencies-metadata`, 

    userTypeCreateOrUpdate: `${commonUrl}/ekutir/master`,
    getAlluserType: `${commonUrl}/ekutir/master`,
    userTypeGetById: `${commonUrl}/ekutir/master`,
    deleteUserType: `${commonUrl}/ekutir/master`,
    patchApi: `${commonUrl}/ekutir/master`,

    subscriptionCreateOrUpdate: `${commonUrl}/ekutir/subscription-plans`, 
    getAllSubscription: `${commonUrl}/ekutir/subscription-plans`, 
    subscriptionGetById: `${commonUrl}/ekutir/subscription-plans`, 
    deleteSubscription: `${commonUrl}/ekutir/subscription-plans`, 
    subscriptionPatchApi: `${commonUrl}/ekutir/subscription-plans`, 
    subscriptionMetaData: `${commonUrl}/ekutir/subscription-plans/metadata`, 
    initiativePlans: `${commonUrl}/ekutir/initiative-subscription-plans`,

    initiativeCreateOrUpdate: `${commonUrl}/ekutir/initiative`,
    getAllInitiative: `${commonUrl}/ekutir/initiative`,
    initiativeGetById: `${commonUrl}/ekutir/initiative`,
    deleteInitiative: `${commonUrl}/ekutir/initiative`,
    initiativePatchApi: `${commonUrl}/ekutir/initiative`,
    initiativeCreateAdmin: `${commonUrl}/ekutir/initiative/admin`,
    initiativeCreateCreator: `${commonUrl}/ekutir/initiative/creator`,
    initiativeMetaData: `${commonUrl}/ekutir/initiative/metadata`, 

    getAllUserManagement: `${commonUrl}/ekutir/user-management`,
    userManagementGetById: `${commonUrl}/ekutir/user-management`,
    userPatchApi: `${commonUrl}/ekutir/user-management`,
    userDeleteApi: `${commonUrl}/ekutir/user-management`,
    impersonateUser: `${commonUrl}/ekutir/user-management`,
    mobileLoginCode: `${commonUrl}/ekutir/user-management`,
    logoutAllDevices: `${commonUrl}/ekutir/user-management`,
    userManagementUpdate: `${commonUrl}/ekutir/user-management`,
    mobileUsersAgents: `${commonUrl}/ekutir/mobile-users/agents`,
    mobileUsersFarmers: `${commonUrl}/ekutir/mobile-users/farmers`,
    dareApprovals: `${commonUrl}/ekutir/dare-approvals`,

    analyticsCountries: `${commonUrl}/ekutir/analytics/countries`,

    countryManagementCreateOrUpdate: `${commonUrl}/ekutir/countries`, 
    getAllcountryManagement: `${commonUrl}/ekutir/countries`, 
    countryManagementGetById: `${commonUrl}/ekutir/countries`, 
    deleteCountryManagement: `${commonUrl}/ekutir/countries`,
    countryManagementMetaData: `${commonUrl}/ekutir/country-metadata`,
    countryGeoImport: `${commonUrl}/ekutir/countries`,
    countryGeoImportStatus: `${commonUrl}/ekutir/countries`,
    countryAdministrativeLocations: `${commonUrl}/ekutir/countries`,

    ecosytemIntegatorCreateOrUpdate: `${commonUrl}/ekutir/ecosystem-integrators`,
    getAllEcosytemIntegator: `${commonUrl}/ekutir/ecosystem-integrators`,
    ecosytemIntegatorGetById: `${commonUrl}/ekutir/ecosystem-integrators`,
    deleteEcosytemIntegator: `${commonUrl}/ekutir/ecosystem-integrators`,
    ecosytemIntegatorMetaData: `${commonUrl}/ekutir/ecosystem-integrators/metadata`,
    ecosytemIntegatorTypes: `${commonUrl}/ekutir/ecosystem-integrators/types`,
    ekScoreCommercialTerms: `${commonUrl}/ekutir/ecosystems`,
    initiativeRedirects: `${commonUrl}/ekutir/initiative-redirects`,

    cropsCreateOrUpdate: `${commonUrl}/ekutir/crops`,
    getAllCrops: `${commonUrl}/ekutir/crops`,
    cropsGetById: `${commonUrl}/ekutir/crops`,
    deleteCrops: `${commonUrl}/ekutir/crops`,
    patchCropsApi: `${commonUrl}/ekutir/crops`,

    appCatalogueCreateOrUpdate: `${commonUrl}/ekutir/app-catalogue`,
    getAllAppCatalogue: `${commonUrl}/ekutir/app-catalogue`,
    appCatalogueGetById: `${commonUrl}/ekutir/app-catalogue`,
    deleteAppCatalogue: `${commonUrl}/ekutir/app-catalogue`,
    appCataloguePatchApi: `${commonUrl}/ekutir/app-catalogue`,

    appServiceCreateOrUpdate: `${commonUrl}/ekutir/app-catalogue`,
    appServicePatchApi: `${commonUrl}/ekutir/app-catalogue`,

    questionnaireCatalogues: `${commonUrl}/ekutir/questionnaire-catalogues`,

    rainfallBaselines: `${commonUrl}/ekutir/climate/rainfall-baselines`,
    soilMoistureThresholds: `${commonUrl}/ekutir/climate/soil-moisture-thresholds`,
    heavyRainThresholds: `${commonUrl}/ekutir/climate/heavy-rain-thresholds`,
    mspPrices: `${commonUrl}/ekutir/climate/msp`,
    cropAliases: `${commonUrl}/ekutir/climate/crop-aliases`,
    referenceCoverage: `${commonUrl}/ekutir/climate/reference-coverage`,

    seasonCalendars: `${commonUrl}/ekutir/season-calendars`,

    rescoreRuns: `${commonUrl}/ekutir/ek-score/rescore-runs`,

    emailConfiguration: `${commonUrl}/ekutir/email-configuration`,
    smsConfiguration: `${commonUrl}/ekutir/sms-configuration`,
    featureFlags: `${commonUrl}/ekutir/feature-flags`,
    loginPageCards: `${commonUrl}/ekutir/login-page-cards`,
};

export default apiEndPoints;